export const EMAIL_VALIDATION_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const YOUTUBE_LINK_REGEX =
  /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;

export const DOMAIN_REGEX = /^[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
export const SUB_DOMAIN_REGEX_PREFIX = /^[a-zA-Z0-9-]+$/;
